var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-container c-main-shadow"},[_c('div',{staticClass:"c-flex"},[(_vm.showChat)?_c('chat',{ref:"chat",staticClass:"s",attrs:{"talkList":_vm.talkList,"singleScreen":_vm.isSingleScreen}}):_vm._e(),_vm._v(" "),(_vm.showList)?_c('talk-list',{attrs:{"talkList":_vm.talkList,"singleScreen":_vm.isSingleScreen}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }